/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "ap-south-1",
    "aws_appsync_graphqlEndpoint": "https://r7drg5nxwrfljdkklcolue5qdq.appsync-api.ap-south-1.amazonaws.com/graphql",
    "aws_appsync_region": "ap-south-1",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-bbcoo6zwuncnvcriik5yklwkii",
    "aws_cognito_identity_pool_id": "ap-south-1:01b74925-af3f-4ca1-8996-b2b32eb72999",
    "aws_cognito_region": "ap-south-1",
    "aws_user_pools_id": "ap-south-1_ghjJh2xUI",
    "aws_user_pools_web_client_id": "2tu0b9v7oc9qcmk84sti8jg3lv",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [],
    "aws_cognito_mfa_configuration": "OPTIONAL",
    "aws_cognito_mfa_types": [
        "SMS",
        "TOTP"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 6,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "PHONE_NUMBER"
    ],
    "aws_user_files_s3_bucket": "scrappy181944-prod",
    "aws_user_files_s3_bucket_region": "ap-south-1"
};


export default awsmobile;
